import React from 'react';
import Investors from '../../components/Investors';

export default async function action({ locale }) {
    return {
        title: locale && locale.startsWith('es')
            ? 'Inversores - NAVEGA'
            : 'Investors - NAVEGA',
        description: locale && locale.startsWith('es')
            ? 'Oportunidad de inversion en NAVEGA - El futuro global del alquiler de botes'
            : 'Investment opportunity in NAVEGA - The global future of boat rentals',
        chunk: 'investors',
        component: <Investors locale={locale} />,
    };
}
